import { useData } from '@app/data/repositories';
import { TasksScreen } from './TasksScreen';
import { useTasks } from './useTasks';

/** Вход экрана «Задачи»: данные и навигация здесь, сам экран о них не знает. */
export function TasksRoute({
  onOpenTask,
  onOpenCase,
  creating,
  onCreatingChange,
}: {
  onOpenTask: (id: string) => void;
  onOpenCase: (id: string) => void;
  creating: boolean;
  onCreatingChange: (creating: boolean) => void;
}) {
  const { db } = useData();
  const { state, actions } = useTasks(db);

  return (
    <TasksScreen
      state={state}
      actions={actions}
      onOpenTask={onOpenTask}
      onOpenCase={onOpenCase}
      creating={creating}
      onCreatingChange={onCreatingChange}
    />
  );
}
